import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/onboarding")({
	component: OnboardingLayout,
});

function OnboardingLayout() {
	return (
		<div className="min-h-dvh bg-background">
			<Outlet />
		</div>
	);
}
